import { useCentrixApi } from "core/hooks/useCentrixApi";
import { useRouter } from "next/router";
import { useMemo } from "react";

export function usePaymentRequestDocuments(paymentRequestId?: string) {
  // get current documents
  const { query } = useRouter();
  const currentPaymentRequestId = paymentRequestId ?? query?.paymentRequestId;
  const { data, isError, isLoading, mutate } = useCentrixApi({
    path: "/api/app/payment-request-document",
    parameters: {
      query: { PaymentRequestId: currentPaymentRequestId as string },
    },
  });

  const documents = useMemo(
    () => (data && Array.isArray(data?.items) ? data.items : []),
    [data]
  );

  return {
    data,
    isError,
    isLoading,
    mutate,
    documents,
  };
}
